<template>
    <section>
        <div class="container container-app">
            <div v-if="showSplash" class="w-100 text-center mt-4">
                <img class="w-100" src="./../../assets/intro.gif" alt="intro"> 
            </div>
            <section v-else class="position-relative">
                <div class="row mt-5">
                    <div class="col-4">
                    </div>
                    <div class="col-4 mt-5">
                        <img class="w-100" src="./../../assets/logo.svg" alt="Logo" />
                    </div>
                    <div class="col-4">
                    </div>
                </div>
                <div class="mt-5 mb-3 text-center" v-if="showConfirmMessage">
                    <span class="confirm-register-message text-center mt-5">{{ $t('login.confirm_register_message') }}</span>
                </div>
                <div class="mt-5 mb-3 text-center" v-if="showForgotMessage">
                    <span class="confirm-register-message text-center mt-5">{{ $t('login.forgot_message') }}</span>
                </div>
                <div class="mt-5 mb-3 text-center" v-if="confirmInvalidMessage">
                    <span class="text-danger text-center mt-5">{{ $t('login.confirm_invalid_message') }}</span>
                </div>
                <div class="mt-5 mb-3 text-center" v-if="confirmValidMessage">
                    <span class="confirm-register-message text-center mt-5">{{ $t('login.confirm_valid_message') }}</span>
                </div>
                <div class="mt-5 mb-5">
                    <h3 class="login-title text-center mt-5">{{ $t('login.welcome') }}</h3>
                </div>
                <form @submit="doLogin">
                    <div class="form-group position-relative">
                        <span class="login-input-title float-left">{{ $t('login.username') }}</span>
                        <input type="text" class="form-control form-control--canvassing border-bottom" :placeholder="$t('login.username_placeholder')" v-model="form.username" id="username">
                        <div v-if="hasError(errors, 'username')">
                            <span class="text-danger">{{errors.username[0]}}</span>
                        </div>
                    </div>
                    <div class="form-group position-relative">
                        <span class="login-input-title float-left">{{ $t('login.password') }}</span><router-link :to="{ name: 'forgot' }" class="login-input-title float-right">{{ $t('login.forgot_password') }}</router-link>
                        <input type="password" class="form-control form-control--canvassing border-bottom" :placeholder="$t('login.password_placeholder')" v-model="form.password" id="password">
                        <div v-if="hasError(errors, 'password')">
                            <span class="text-danger">{{errors.password[0]}}</span>
                        </div>
                    </div>

                    <button type="submit" class="btn shadow btn-app btn-block mb-5 mt-5 primaryBackground">{{ $t('login.login') }}</button>
                    <div class="text-center mb-5"><span class="dont-have-account">{{ $t('login.dont_have_an_account') }}</span>&nbsp;<router-link class="signup-link" :to="{ name: 'register' }">{{ $t('login.sign_up') }}</router-link></div>
                </form>
            </section>
        </div>
    </section>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "Login",
        mixins: [HelperMixin],
        data() {
            return {
                showSplash: true,
                confirmInvalidMessage: false,
                confirmValidMessage: false,
                form: {
                    username: "",
                    password: "",
                },
                errors: {
                    username: [],
                    password: [],
                }
            }
        },
        computed: {
            showConfirmMessage() {
                return this.$store.getters["showConfirmMessage"];
            },
            showForgotMessage() {
                return this.$store.getters["showForgotMessage"];
            }
        },
        created() {
            if (typeof message != 'undefined') {
                if (message === 'Invalid token') {
                this.confirmInvalidMessage = true;
                }
                if (message === 'Account confirmed') {
                    this.confirmValidMessage = true;
                }
            }
            this.$store.dispatch('saveIsLoading', {
                isLoading: false
            });
        },
        mounted() {
            let _this = this;
            setTimeout(function () {
                _this.showSplash = false; 
                 _this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });
                setTimeout(function () {
                    _this.$store.dispatch('saveIsLoading', {
                        isLoading: false
                    });
                }, 300);
            }, 1500);
        },
        methods: {
            resetErrors() {
                this.errors = {
                    username: [],
                    password: [],
                };
            },

            resetForm() {
                this.form = {
                    username: "",
                    password: "",
                };
            },

            doLogin(evt) {
                evt.preventDefault();
                if (!this.$store.getters['online']) {
                    $('#featureUnavailableOfflineModal').modal('show');
                    return false;
                }
                this.form.username = this.form.username.toLowerCase();
                this.resetErrors();

                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                axios.post(
                        '/api/v1/user/login',
                        this.form
                ).then(this.consumedoLogin, this.errordoLogin);
            },

            consumedoLogin: function (response) {
                this.$store.dispatch('showConfirmMessage', {
                    showConfirmMessage: false
                });
                this.$store.dispatch('showForgotMessage', {
                    showForgotMessage: false
                });
                this.$store.dispatch('saveToken', {
                    token: response.data.data.token.access_token,
                    remember: true
                });
                this.$store.dispatch('saveUser', {
                    user: response.data.data.user
                });
                this.$store.dispatch('saveCampaignsList', {
                    campaignsList: response.data.data.campaigns
                });
                this.$store.dispatch('saveAlerts', {
                    alerts: response.data.data.alerts
                });
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                if (localStorage.refreshData) {
                    var dataStorage = JSON.parse(localStorage.refreshData);
                    if (response.data.data.user._id != dataStorage.user._id) {
                        localStorage.removeItem('refreshData');
                        for (let n = 0; n < localStorage.length; n++) {
                            const thisKey = localStorage.key(n);
                            if (thisKey.includes("offlineLocationToProcess")) {
                                localStorage.removeItem(thisKey);
                            }
                        }
                        this.$store.dispatch('refreshOfflineLocations');
                    }
                }
                localStorage.refreshData = JSON.stringify(response.data.data);
                this.resetForm();
                this.$router.replace({ name: "campaign_list"});
            },

            errordoLogin: function (error) {
                this.$store.dispatch('showConfirmMessage', {
                    showConfirmMessage: false
                });
                this.$store.dispatch('showForgotMessage', {
                    showForgotMessage: false
                });
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                if (
                        error.response !== undefined &&
                        error.response.data !== undefined &&
                        error.response.data.responseType === 'Error' &&
                        error.response.data.errorMessage !== undefined &&
                        Array.isArray(error.response.data.errorMessage)
                    ) {
                        if (error.response.data.errorMessage.includes("validation_password_required")) {
                            this.errors.password = [this.$t('login.errors.password_required')];
                        }
                        if (error.response.data.errorMessage.includes("validation_username_required")) {
                            this.errors.username = [this.$t('login.errors.username_required')];
                        }
                        if (error.response.data.errorMessage.includes("unauthorized")) {
                            this.errors.username = [this.$t('login.errors.invalid_credentials')];
                            this.errors.password = [this.$t('login.errors.invalid_credentials')];
                        }
                }
                console.log(error);
            },
        },
    };
</script>
